module.exports = "/_next/static/images/overview-right-7be1166343653c7de36f616aad5cb0ef.png";